import React from 'react';
import { Link } from '@nerdwallet/currency';

export default {
  tiles: [
    {
      id: 0,
      title: 'NerdWallet logos',
      copy: (
        <React.Fragment>
          When using our logos, please refer to our{' '}
          <Link href="https://www.nerdwallet.com/l/logo-partner-usage">
            best practices
          </Link>
          .
        </React.Fragment>
      ),
      image:
        'https://www.nerdwallet.com/cdn/company/2021/kit/images/Press-Kit_Desktop_Logos-image.jpg',
      isNarrow: true,
      linkCopy: 'Download',
      linkUrl:
        'https://www.nerdwallet.com/cdn/company/2021/kit/downloads/NW_logos.zip',
    },
    {
      id: 1,
      title: 'Product shots',
      image:
        'https://www.nerdwallet.com/cdn/company/2021/kit/images/Press-Kit_Desktop_Product-image.jpg',
      isNarrow: true,
      linkCopy: 'Download',
      linkUrl:
        'https://www.nerdwallet.com/cdn/company/2021/kit/downloads/NW-product-shots.zip',
    },
    {
      id: 2,
      title: 'Leadership headshots',
      image:
        'https://www.nerdwallet.com/cdn/company/2021/kit/images/Press-Kit_Desktop_Leadership-Headshots-image.jpg',
      isNarrow: true,
      linkCopy: 'Download',
      linkUrl:
        'https://www.nerdwallet.com/cdn/company/2021/kit/downloads/NW-leadership-2021.zip',
    },
    {
      id: 3,
      title: 'Office shots',
      image:
        'https://www.nerdwallet.com/cdn/company/2021/kit/images/Press-Kit_Desktop_Office-Shots-image.jpg',
      isNarrow: true,
      linkCopy: 'Download',
      linkUrl:
        'https://www.nerdwallet.com/cdn/company/2021/kit/downloads/NW_office-shots.zip',
    },
    {
      id: 4,
      title: 'B-roll videos',
      copy: (
        <React.Fragment>
          If you’d like to use these assets, please reach out to us at,{' '}
          <Link href="mailto:press@nerdwallet.com">press@nerdwallet.com</Link>.
        </React.Fragment>
      ),
      image:
        'https://www.nerdwallet.com/cdn/company/2021/kit/images/Press-Kit_Desktop_Broll-Video-image.jpg',
      isNarrow: true,
    },
  ],
};
